import { css } from '@/styled-system/css';

export const gleamRootStyles = css.raw({
  display: 'inline-flex',
  position: 'relative',
});
